import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthService from '../services/auth';
import FullScreenLayout from '../layouts/FullScreenLayout';
import { routesPath } from '../App';

const FullScreenRoute = ({ children, breadcrumbs = [] }) => {
  const [user, setUser] = useState(null);
  const location = useLocation();
  const isAuthenticated = AuthService.isAuthenticated();
  
  // Check for test mode bypass
  const searchParams = new URLSearchParams(location.search);
  const skipAuth = searchParams.get('skipAuth') === 'true' || 
                   process.env.REACT_APP_SKIP_AUTH === 'true' ||
                   window.localStorage.getItem('skipAuth') === 'true';
  
  useEffect(() => {
    if (isAuthenticated) {
      const currentUser = AuthService.getCurrentUser();
      setUser(currentUser);
    } else if (skipAuth) {
      // Create a mock user for testing
      setUser({
        email: 'test@example.com',
        name: 'Test User',
        userId: 'test-user-id'
      });
    }
  }, [isAuthenticated, skipAuth]);
  
  // Bypass authentication for testing
  if (skipAuth) {
    console.log('⚠️ Authentication bypassed for testing');
    return (
      <FullScreenLayout user={user} breadcrumbs={breadcrumbs}>
        {children}
      </FullScreenLayout>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to={routesPath.connect} replace />;
  }
  
  return (
    <FullScreenLayout user={user} breadcrumbs={breadcrumbs}>
      {children}
    </FullScreenLayout>
  );
};

export default FullScreenRoute;

